import React, { Component } from 'react';
import {TextField, Autocomplete, Tooltip as ToolTip, FormControlLabel, Checkbox, Paper, IconButton, InputBase} from '@mui/material';
import axios from "axios";
import Api from "../../customlib/Api";
import ReactLoading from 'react-loading';
import { Save, CancelRounded } from "@mui/icons-material";

class ContactEditChangeSales extends Component {
    state = { 
        selectedSales : {},//id = id, contactId, name
        isAssigned : false,
        isChecked : false,
        salesData: [],
        isLoading: false,
        isResetLabel: false
    }

    handleSelectionChanged = (salesName) => {
        const salesData = [...this.props.salesData];
        // console.log("SALESDATA : ", salesData);
        let selected = salesData.filter((sales) => sales.name===salesName);
        console.log("FINDSELECTION : ", selected);

        if(selected.length > 0){

            let newData = JSON.parse(JSON.stringify(selected[0]));

            newData.contactId = this.props.contactData.id;
            this.setState({selectedSales: newData}, ()=>{
                if(this.state.isChecked){
                    this.props.onChecked(newData);
                }
            });
        }

    }

    handleAssignContactToSales = () => {
       
        if(this.state.selectedSales.id === undefined | this.state.selectedSales.id <= 0 ){
            return;
        }

        var params = {
            contactId: this.props.contactData.id, 
            userId: this.state.selectedSales.id,
            resetLabel: this.state.isResetLabel
        };

        console.log("PARAMASSIGN : ", params);
        // return; 

        this.setState({isLoading: true}, () => {
            axios
            .post(Api.assignContactToUser(), params, Api.getRequestHeaderJsonNew())
            .then((response) => {
                console.log("ASSIGNRESPONSE : ", response.data);
                let responseData = response.data;
                if(responseData.success){
                    this.setState({isAssigned: true, isLoading: false});
                    // return;
                    var contactData = this.props.contactData;
                    contactData.assignToUser = this.state.selectedSales.id;
                    contactData.assignToUserName = this.state.selectedSales.name;
                    contactData.label = this.state.selectedSales.label;
                    this.props.onFinishEdit(contactData);
                }else{
                    this.setState({isLoading: false});
                }
                
            })
            .catch((error) => {
                this.setState({isLoading: false});
                console.error("There was an error!", error);
            });
        });
    }

    handleCheckBoxChange = (event) => {
        console.log("CHECKBOX_CHANGED");
        this.setState({isChecked: event.target.checked}, ()=>{
            if(event.target.checked){
                this.props.onChecked(this.state.selectedSales);
            }else{
                this.props.onUnchecked(this.state.selectedSales);
            }
        });
      }

    componentDidMount() {

        this.setState(
            {
                salesData : this.props.salesData
            },()=>{
                this.handleSelectionChanged(this.props.contactData.assignToUserName);
            }
        );

    }

    componentDidUpdate(prevProps, prevState) {
        
    }

    render() { 
        // console.log("SELECTEDSALES : ", this.state);
        const { from, fromName, lastMessage, assignToUserName} = this.props.contactData;
        return ( 
            <div>
                <div className="row">
                    <div className="col-11">
                        <Paper
                            component="form"
                            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center'}}
                            >
                            <IconButton sx={{ p: '10px' }} aria-label="menu">
                                <ToolTip title="Simpan">
                                    <Save style={{cursor: "pointer"}} className="text-primary" onClick={this.handleAssignContactToSales} /> 
                                </ToolTip>
                            </IconButton>
                            <Autocomplete
                                id="free-solo-2-demo"
                                size='small'
                                // disableClearable
                                freeSolo 
                                options={this.props.salesData.map((option) => {
                                    return String(option.name);
                                })}
                                onChange={(event, newValue) => {
                                    this.handleSelectionChanged(newValue);
                                }} 
                                value={assignToUserName}
                                fullWidth
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Pilih sales online"
                                    margin="0"
                                    variant="outlined"
                                    size='small'
                                    InputProps={{ ...params.InputProps, type: 'search' }}
                                />
                                )}
                            />
                            <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                <ToolTip title="Batal">
                                    <CancelRounded style={{cursor: "pointer"}} className="text-danger" onClick={() => {this.props.onFinishEdit(this.props.contactData)}} /> 
                                </ToolTip>
                            </IconButton>
                        </Paper>
                    </div>
                    <div className="col-1 text-center">
                        
                        {/* {
                            this.state.isLoading ? (<></>) : 
                            (
                                <div style={{marginTop: 3}}>
                                    <ToolTip title="Simpan">
                                        <Save style={{cursor: "pointer"}} className="text-primary" onClick={this.handleAssignContactToSales} /> 
                                    </ToolTip>
                                    <ToolTip title="Batal">
                                        <CancelRounded style={{cursor: "pointer"}} className="text-danger" onClick={() => {this.props.onFinishEdit(this.props.contactData)}} /> 
                                    </ToolTip>
                                </div>
                            )
                        } */}
                        
                        <div style={{marginTop: 12}}>
                            {
                                this.state.isLoading ? 
                                <ReactLoading color="#FF0000" type="spin" width={30} height={10}/> : 
                                <span></span>
                            }
                        </div>
                    </div>
                </div>
            </div>
         );
    }
}
 
export default ContactEditChangeSales;